import { ActionType } from "../action-type.constant.t";
import { User } from "../types";

type UserAction = {
  type: string;
  payload?: User;
};

const initState = {
  personId: 0,
}

export default function userReducer(state: User = initState, action: UserAction) {
  switch (action.type) {
    case ActionType.SET_USER:
      return {
        ...state,
        ...action.payload,
      };
    case ActionType.REMOVE_USER:
      return initState;
    default:
      return state;
  }
}